export default __webpack_public_path__ + "files/BC2.pdf";